export enum FileFormat {
  JSON = 'JSON',
  CSV = 'CSV'
}
